export const routes = {
  eCommerce: {
    dashboard: '/',
    products: '/ecommerce/products',
    createProduct: '/ecommerce/products/create',
    productFormDetails: (id: string) => `/ecommerce/products/${id}/edit-form`,
    productDetails: (slug: string) => `/ecommerce/products/${slug}`,
    ediProduct: (slug: string) => `/ecommerce/products/${slug}/edit`,
    categories: '/ecommerce/categories',
    createCategory: '/ecommerce/categories/create',
    editCategory: (id: string) => `/ecommerce/categories/${id}/edit`,
    subCategories: '/ecommerce/subCategories',
    createSubCategory: '/ecommerce/subCategories/create',
    editSubCategory: (id: string) => `/ecommerce/subCategories/${id}/edit`,
    brands: '/ecommerce/brands',
    createbrand: '/ecommerce/brands/create',
    editbrand: (id: string) => `/ecommerce/brands/${id}/edit`,
    units: '/ecommerce/units',
    createunit: '/ecommerce/units/create',
    editunit: (id: string) => `/ecommerce/units/${id}/edit`,
    customers: '/ecommerce/customers',
    createCustomer: '/ecommerce/customers/create',
    editCustomer: (id: string) => `/ecommerce/customers/${id}/edit`,
    orders: '/ecommerce/orders',
    deliveryOrders: '/ecommerce/deliveryManOrder',
    // deliveryManOrder
    orderDetails: (id: string) => `/ecommerce/orders/${id}`,
    editOrder: (id: string) => `/ecommerce/orders/${id}/edit`,
    editRefund: (id: string) => `/ecommerce/refunds/${id}/edit`,
    reviews: '/ecommerce/reviews',
    shop: '/ecommerce/shop',
    cart: '/ecommerce/cart',
    checkout: '/ecommerce/checkout',
    trackingId: (id: string) => `/ecommerce/tracking/${id}`,
    refunds: '/ecommerce/refunds',
    orderreports: '/ecommerce/orderreports',

    salereports: '/ecommerce/salesreport',

    productreports: '/ecommerce/productreport',

    vendorNewProducts: '/ecommerce/vendorNewProducts',
    vendorApprovedProducts: '/ecommerce/vendorApprovedProducts',
    vendorDeniedProducts: '/ecommerce/vendorDeniedProducts',
    banners: '/ecommerce/banner',
    bannerDetails: (id: string) => `/banner/${id}`,
    editBanner: (id: string) => `/ecommerce/banner/${id}/edit`,

    // bannerDetails: (id: string) => `/banner/${id}`,
    // editBanner: (id: string) => `/ecommerce/banner/${id}/edit`,

    communities: '/ecommerce/community',
    communityDetails: (id: string) => `/community/${id}`,
    editcommunity: (id: string) => `/ecommerce/community/${id}/edit`,

    storiesProduct: '/ecommerce/storyproduct',
    storyProductDetails: (id: string) => `/storyproduct/${id}`,
    editstoryProduct: (id: string) => `/ecommerce/storyproduct/${id}/edit`,

    attributes: '/ecommerce/attributes',
    coupons: '/ecommerce/coupons',
    wholesaler: '/ecommerce/wholesalersList',
    createWholesaler: '/ecommerce/wholesaler/create',
    mywholesalers: '/ecommerce/wholesaler',
    wholesalersRequest: '/ecommerce/wholesalerRequest',
    editWholesaler: (id: string) => `/ecommerce/wholesaler/${id}/edit`,
    connectionRequst: '/ecommerce/connectRequest',
    logo: '/ecommerce/logo',
    wholesalerProductDetail: (id: string) => `/ecommerce/wholesaler/${id}/edit`,
    employeeWholesalerProduct: (id: string) =>
      `/ecommerce/employeesOrder/${id}/edit`,
    wholesalerDetail: (id: string) => `/ecommerce/wholesalerRequest/${id}`,
    wholesalerKyc: '/ecommerce/wholesaler-kyc-form',
    wholesalerBranding: '/ecommerce/wholesaler/branding',
    wholesalerRetailers: '/ecommerce/wholesaler/retailers',
    wholesalerPlanPricing: '/ecommerce/wholesaler/plan-pricing',
    aiSales: '/ai-sales',
    deliveryMan: '/ecommerce/delivery-man',
    deliveryManOrder: '/ecommerce/delivery-man-order',
    createDeliveryMan: '/ecommerce/delivery-man/create',
    EditDeliveryMan: (id: string) => `/ecommerce/delivery-man/${id}/edit`,
    deliveryManChatList: `/ecommerce/delivery-man/chat-list`,
    deliveryManViewDetail: (id: string) => `/ecommerce/delivery-man/${id}/view`,
    deliveryManChat: (id: string) => `/ecommerce/delivery-man/chat`,
    reseller: `/ecommerce/reseller`,
    resellerViewDetail: (id: string) => `/ecommerce/reseller/${id}`,
    employees: `/ecommerce/employees`,
    createEmployees: `/ecommerce/employees/create`,
    EditEmployee: (id: string) => `/ecommerce/employees/${id}`,
    employeeViewDetail: (id: string) => `/ecommerce/employees/${id}/view`,
    employeeOverview: `/ecommerce/employees/overview`,
    employeePerformance: `/ecommerce/employees/performance`,
    employeeKpiSettings: `/ecommerce/employees/kpi-settings`,
    addTheme: `/ecommerce/theme-upload/create`,
    themeList: `/ecommerce/theme-upload`,
    testimonialList: `/ecommerce/testimonial`,
    LiveSale: `/LiveSale`,
    enquires: '/enquires',
    FlashSale: `/FlashSale`,
    DealOfTheDay: `/DealOfTheDay`,
    FeaturedDeal: `/FeaturedDeal`,
    FbCampaign: '/ecommerce/fbcampaign',
    FbCreateCampaign: '/ecommerce/fbcampaign/create',
    FbAds: '/ecommerce/fbAds',
    FbCreateAds: '/ecommerce/fbAds/create',
    FbAdSets: '/ecommerce/fbAdset',
    FbCreateAdSets: '/ecommerce/fbAdset/create',
    FbCreative: '/ecommerce/fbCreative',
    FbCreateCreative: '/ecommerce/fbCreative/create',
    FbLeads: '/ecommerce/fbLeads',
    CRMAdmin: '/crm/admin',
    CRMLeads: '/crm/leads',
    CRMTelecallers: '/crm/telecallers',
    CRMFollowups: '/crm/followups',
    CRMPerformance: '/crm/performance',
    CRMSettings: '/crm/settings',
    CRMLeadSources: '/crm/lead-sources',
    vendorsreports: '/ecommerce/vendors/create',
    vendors: '/ecommerce/vendors',
    EditVendor: (id: string) => `/ecommerce/vendors/${id}`,
    vendorViewDetail: (id: string) => `/ecommerce/vendors/${id}/view`,
    vendorProducts: '/ecommerce/vendor-products',
    verifywholesaler: '/ecommerce/verifywholesaler',
    amountLocker: '/ecommerce/amountLocker',
    resellerImport: '/ecommerce/resellerImport',
    subscription: '/ecommerce/resellerSubscription',
    metaData: '/ecommerce/metaData',
    commission: '/ecommerce/commission',
    deletedUsers:'/ecommerce/deleted-users',
    InstaCampaign: '/ecommerce/instacampaign',
    InstaCreateCampaign: '/ecommerce/instacampaign/create',
    InstaCampaignAdsetView: (id: string) =>
      `/ecommerce/instacampaign/${id}/view`,
    InstaAds: '/ecommerce/instaAds',
    InstaCreateAds: '/ecommerce/instaAds/create',
    InstaAdSets: '/ecommerce/instaAdset',
    InstaCreateAdSets: '/ecommerce/instaAdset/create',
    InstaCreative: '/ecommerce/instaCreative',
    InstaCreateCreative: '/ecommerce/instaCreative/create',
  },
  support: {
    messageDetails: (messageId: string) => `/support/messages/${messageId}`,
    inbox: '/support/inbox',
    myTickets: '/support/my-tickets',
    raiseTicket: '/support/my-tickets/new',
    ticketDetail: (id: string) => `/support/tickets/${id}`,
    // Other support routes...
  },
  features: '/features',
  analytics: '/analytics',
  pos: '/pos',
  posSales: '/pos/sales',
  posRegister: '/pos/register',
  posStock: '/pos/stock',
  posSettings: '/pos/settings',
  posStaff: '/pos/staff',
  deliveryRates: '/delivery-rates',
  pages: '/media',
  socialMedia: '/social-media',
  paymentGateway: '/plugin', //
  communityPlugins: '/community-plugins',
  pluginDetails: (slug: string) => `/plugin/${slug}`,
  onboardingSetup: '/onboarding-setup',
  general: '/general',
  themeSetup: '/theme',
  themeDetails: (id: string) => `/theme/${id}`,
  marketplace: '/marketplace',
  mobileSetup: '/mobileSetup',
  appSetup: '/app',
  appList: '/app-list',
  enquires:'/enquires',
  whatsappSetup: '/whatsapp',
  whatsappTemplates: '/whatsapp/templates',
  whatsappApiDocs: '/whatsapp/api',
  firebaseSetup: '/firebase-setup',
  twilioSetup: '/twilio',
  googlePlugin:'/googlePlugin',
  blog:'/Blog',
  billinginvoice: '/billinginvoice',
  twofactorSetup: '/twofactor',
  pixel: '/pixel',
  poPage: '/popage',
  proformaPage: '/proformaPage',
  proFormaListTable: '/proFormaListTable',
  poPageList: '/popageList',
  pixel2: '/pixel2',
  shipRocket: '/shiprocket',
  googleanalytics: '/googleanalytics',
  pixelSetting: 'pixelSetting',
  razorpaySetup: '/razorpay',
  plans: '/subscription-plan',
  beneficary: '/beneficiary',
  businessCategory: '/business-category',
  wallets: '/wallets',
  recharge: '/recharge',
  themeReacharged: '/themeReacharge',
  projectList: '/DeveloperProject',
  adminProjectList: '/adminProjectList',
  adminSaleTheme: '/adminSaleTheme',
  walletReports: '/wallet-reports',
  withdrawReports: '/withdraw-reports',
  paymentsSettings: '/payments-settings',
  attributesUnitsSettings: '/attributes-units-settings',
  cashFree: '/cashFree',
  phonePay: '/phonePay',
  payu: '/payu',
  razorpay: '/razorpay',
  stripe: '/stripe',
  paymentGateways: '/payment-gateways',
  facebook: '/facebook',
  facebookCreateAd: '/facebook/create',
  instagram: '/instagram',
  withdrawRequestView: (id: string) => `/withdraw-reports/${id}`,
  subscriberReports: '/subscriber-reports',
  invoice: {
    home: '/invoice',
    create: '/invoice/create',
    details: (id: string) => `/invoice/${id}`,
    edit: (id: string) => `/invoice/${id}/edit`,
  },
  widgets: {
    cards: '/widgets/cards',
    icons: '/widgets/icons',
    charts: '/widgets/charts',
    maps: '/widgets/maps',
  },
  tables: {
    basic: '/tables/basic',
    collapsible: '/tables/collapsible',
    enhanced: '/tables/enhanced',
    pagination: '/tables/pagination',
    search: '/tables/search',
    stickyHeader: '/tables/sticky-header',
  },
  multiStep: '/multi-step',
  forms: {
    profileSettings: '/forms/profile-settings',
    billingSettings: '/forms/profile-settings/billing',
    notificationPreference: '/forms/profile-settings/notification',
    personalInformation: '/forms/profile-settings/profile',
    newsletter: '/forms/newsletter',
  },
  search: {
    nft: '/search/nft',
  },
  profile: '/profile',
  welcome: '/welcome',
  comingSoon: '/coming-soon',
  accessDenied: '/access-denied',
  notFound: '/not-found',
  maintenance: '/maintenance',
  blank: '/blank',
  auth: {
    signUp1: '/auth/sign-up-1',

    // sign in
    signIn1: '/auth/sign-in-1',

    wholesalerSignup: '/auth/wholesaler-register',

    partnerSignup: '/auth/partner-register',

    businesswholeseller: '/auth/businesswholeseller-register',

    // forgot password
    forgotPassword1: '/auth/forgot-password-1',
    developer: '/auth/developer-register',
    // OTP
    otp1: '/auth/otp-1',
  },
  signIn: '/signin',
  file: {
    manager: '/file-manager',
    // ... other file related routes
  },
};
